import { atom } from 'recoil';

export const subjectNoticePopupState = atom({
  key: 'subjectNoticePopupState',
  default: {
    visible: false,
    data: null,
  },
});
